import { parseLatexSegments } from 'components/LatexText/parseLatexSegments';

export type OnGoChoiceLabelFontSize = 'default' | 'medium' | 'small' | 'compact';

/** Counts visible label length without LaTeX delimiter characters. */
export const getOnGoChoiceLabelLength = (label: string): number =>
  parseLatexSegments(label).reduce((sum, segment) => {
    if (segment.type === 'text') {
      return sum + segment.content.length;
    }

    if (segment.incomplete) {
      return sum + segment.raw.length;
    }

    return sum + segment.content.length;
  }, 0);

export const resolveOnGoChoiceLabelFontSize = (label: string): OnGoChoiceLabelFontSize => {
  const length = getOnGoChoiceLabelLength(label);

  if (length <= 30) {
    return 'default';
  }

  if (length <= 60) {
    return 'medium';
  }

  if (length <= 90) {
    return 'small';
  }

  return 'compact';
};
